// extracted by mini-css-extract-plugin
module.exports = {"powered-by":"style_powered-by__3mDGE"};